import { useContext, useState, useRef } from "react";
import AppContext from "../context";
import variables from "../styles/export.module.scss";
import { readableColor } from "color2k";

const VideoPlayer = ({ video, tip }) => {
  const { handleSetGlobalModal } = useContext(AppContext);
  const [thumbnailAutoplay, setThumbnailAutoplay] = useState(true);
  const vidRef = useRef(null);

  const stopThumbnail = () => {
    vidRef.current.pause();
    setThumbnailAutoplay(false);
  };

  return (
    <>
      <div className="player-wrapper">
        {video && (
          <div
            className="play-button-container"
            onClick={() => {
              video &&
                handleSetGlobalModal(
                  <div style={{ minWidth: "100%" }}>
                    <video controls autoPlay>
                      <source src={video} type="video/mp4" />
                    </video>
                  </div>,
                  {
                    wide: true,
                    pronouncedCloseButton: true,
                  }
                );
            }}
          >
            <svg
              width="366"
              height="366"
              viewBox="0 0 366 366"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title id="PlayButton">Play button</title>
              <circle
                cx="183"
                cy="183"
                r="183"
                fill={variables.primaryColor}
                fillOpacity="1"
              />
              <path
                d="M268 188L125.5 270.272L125.5 105.728L268 188Z"
                fill={readableColor(variables.primaryColor)}
              />
            </svg>
          </div>
        )}
        {video && (
          <>
            <video
              muted
              className="thumbnail-video"
              id="videoPlayer"
              preload="none"
              /*               autoPlay={thumbnailAutoplay} */
              muted
              loop
              ref={vidRef}
            >
              <source src={video} type="video/mp4" />
            </video>
            <div className="thumbnail-video-controls has-text-white o-5 p-4">
              {/* {thumbnailAutoplay && (
                <div
                  onClick={() => {
                    stopThumbnail();
                  }}
                >
                  <small>Stop autoplay?</small>
                </div>
              )} */}
            </div>
          </>
        )}
        {tip && (
          <div className="video-overlay-tip">
            <p>{tip}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default VideoPlayer;
